import React from 'react';
import classnames from 'classnames';
import Modal from 'react-modal';
import { AltSecondaryButton } from 'scy/buttons';
import styles from './styles.mod.scss';

const SCY_OVERLAY_CLASS_NAME = styles.overlay;

export { SCY_OVERLAY_CLASS_NAME };

export default function ModalContainer({
  isOpen,
  handleClose,
  canClose = true,
  hideCloseButton,
  handleAfterOpen,
  contentLabel = '',
  className,
  afterOpenClassName,
  beforeCloseClassName,
  size,
  children
}) {
  return (
    <Modal
      className={{
        base: classnames(styles.content, className, {
          [styles.smallModal]: size === 'small'
        }),
        afterOpen: classnames(styles.contentAfterOpen, afterOpenClassName),
        beforeClose: classnames(styles.contentBeforeClose, beforeCloseClassName)
      }}
      overlayClassName={{
        base: SCY_OVERLAY_CLASS_NAME,
        afterOpen: styles.overlayAfterOpen,
        beforeClose: styles.overlayBeforeClose
      }}
      closeTimeoutMS={250}
      isOpen={isOpen}
      onRequestClose={handleClose}
      shouldCloseOnOverlayClick={canClose}
      onAfterOpen={handleAfterOpen}
      contentLabel={contentLabel}
      ariaHideApp={false}
    >
      {canClose && !hideCloseButton && (
        <AltSecondaryButton
          noBorder
          className={styles.closeButton}
          onClick={handleClose}
        >
          ✕
        </AltSecondaryButton>
      )}
      {children}
    </Modal>
  );
}
